 import './styles.scss';
 import * as Constants from './constants';
 import BodyPortal from '../BodyPortal';

import React, { useEffect, useRef, useState } from 'react'
import { isIpad, isMobile } from '../../common/util';

const  Tooltip = (props) => {
    const tooltipContainer = useRef(null);
    let timeouts = null;
    const wrapperRef = useRef(null);
    const [tooltipStyles, settooltipStyles] = useState({})
    const [isOpen, setIsOpen] = useState(false);
    const [customStyle, setCustomStyle] = useState(false);




    let getPosition = (position, top, left, elHeight, elWidth, arrowSize) => {
        if (position == 'right') {
            const bottomBoundary = window.innerHeight;
            let newTop = Math.floor(top - (elHeight / 2));
            let arrowTop = null
            if (newTop < 0) {
                newTop = 0;
                arrowTop = top
            } else if (newTop + elHeight > bottomBoundary) {
                newTop = bottomBoundary - elHeight
                arrowTop = elHeight - (bottomBoundary - top)
            }
            return {
                className: arrowTop ? '' : Constants.LEFT_ARROW_CLASS,
                position: {
                    top: newTop,
                    left: left + arrowSize
                },
                arrow: arrowTop ? {
                    top: arrowTop
                } : null
            }
        } else if (position == 'top') {
            return {
                className: Constants.BOTTOM_ARROW_CLASS,
                position: {
                    top: Math.floor(top - elHeight - arrowSize),
                    left: left - arrowSize
                }
            }
        } else if (position == 'left') {
            return {
                className: Constants.RIGHT_ARROW_CLASS,
                position: {
                    top: Math.floor(top - elHeight),
                    left: left - elWidth - arrowSize
                }
            }
        } else if (position == 'bottom') {
            return {
                className: Constants.TOP_ARROW_CLASS,
                position: {
                    top: Math.floor(top + arrowSize),
                    left: left - arrowSize
                }
            }
        }


    }

    let calculateTooltipPosition = () => {
        const rightBoundary = window.innerWidth;
        const bottomBoundary = window.innerHeight;
        const topBoundary = 0;
        const leftBoundary = 0;

        const targetLeft = props.target.left;
        const targetRight = props.target.right;
        const targetTop = props.target.top;
        const targetBottom = props.target.bottom;

        const targetHorCenter = Math.floor(((targetRight - targetLeft) / 2) + targetLeft);
        const targetVerCenter = Math.floor(((targetBottom - targetTop) / 2) + targetTop);

        const elHeight = wrapperRef?.current?.clientHeight ||0;
        const elWidth = wrapperRef?.current?.clientWidth > 564 == true ? 564 : wrapperRef?.current?.clientWidth||0;

        const totalTooltipHeight = elHeight + Constants.ARROW_SIZE;
        const totalTooltipWidth = elWidth + Constants.ARROW_SIZE;

        if (props.position && props.position == 'top') {
            settooltipStyles(getPosition('top', targetTop, targetHorCenter, elHeight, 0, Constants.ARROW_SIZE));
        } else if (props.position && props.position == 'right') {
            settooltipStyles(getPosition('right', targetVerCenter, targetRight, elHeight, 0, Constants.ARROW_SIZE));
        } else if (props.position && props.position == 'left') {
            settooltipStyles(getPosition('left', targetVerCenter, targetLeft, (elHeight / 2), elWidth, Constants.ARROW_SIZE));
        } else if (props.position && props.position == 'bottom') {
            settooltipStyles(getPosition('bottom', targetBottom, targetHorCenter, 0, 0, Constants.ARROW_SIZE));
        } else if (((targetTop - topBoundary) >= (totalTooltipHeight)) && (rightBoundary - targetHorCenter > elWidth)) {
            // Check if tooltip can be rendered on top relative to component position
            settooltipStyles(getPosition('top', targetTop, targetHorCenter, elHeight, 0, Constants.ARROW_SIZE));
        } else if (((rightBoundary - targetRight) >= (totalTooltipWidth)) && ((targetVerCenter - topBoundary) > elHeight)) {
            // Check if tooltip can be rendered on right
           settooltipStyles(getPosition('right', targetVerCenter, targetRight, (elHeight / 2), 0, Constants.ARROW_SIZE));
        } else if (((targetLeft - leftBoundary) >= (totalTooltipWidth)) && ((targetVerCenter - topBoundary) > elHeight)) {
            // Check if tooltip can be rendered on left
            settooltipStyles(getPosition('left', targetVerCenter, targetLeft, (elHeight / 2), elWidth, Constants.ARROW_SIZE));
        } else if (((bottomBoundary - targetBottom) >= (totalTooltipHeight)) && (rightBoundary - targetHorCenter > elWidth)) {
            // Check if tooltip can be rendered underneath
            settooltipStyles(getPosition('bottom', targetBottom, targetHorCenter, 0, 0, Constants.ARROW_SIZE));
        }
        else {
            if (props.toolTipClassName === "diaryCalendar")
                setCustomStyle({ left: '0px' });
            else if(isMobile()){
                setCustomStyle({top: '164px', left: "75px" });
                }
            else
                setCustomStyle({ top: '164px', left: "512px" });
        }
    }

    let hideTooltip = () => {
        if (timeouts) {
            clearTimeout(timeouts);
            timeouts = null;
        }
        timeouts = setTimeout(() => {
            setIsOpen(false);
            props.onTooltipClose();
        }, 30);

    }

    let showTooltip = () => {
        setIsOpen(true);
    
    }

    let onMouseMove = (event) => {
        if (wrapperRef?.current) {
            const tooltipWrapper = wrapperRef?.current?.getBoundingClientRect()
            if ((props.target.left < event.clientX && props.target.right > event.clientX
                && props.target.top < event.clientY && props.target.bottom > event.clientY)
                || (tooltipWrapper.left < event.clientX && tooltipWrapper.right > event.clientX
                    && tooltipWrapper.top < event.clientY && tooltipWrapper.bottom > event.clientY)
            ) {
                if (timeouts) {
                    clearTimeout(timeouts);
                    timeouts = null;
                }
                timeouts = setTimeout(() => {
                    showTooltip()
                }, 500);
            } else {
                hideTooltip();
            }
        } else if (props.target.left < event.clientX && props.target.right > event.clientX
            && props.target.top < event.clientY && props.target.bottom > event.clientY) {
            if (timeouts) {
                clearTimeout(timeouts);
                timeouts = null;
            }
            timeouts = setTimeout(() => {
                showTooltip()
            }, 500);
        } else {
            hideTooltip();
        }
    }

    let handleClickOutside = (event) => {
        if (!wrapperRef?.current?.contains(event.target) && !event.target.classList.contains('ttController')) {
            hideTooltip();
        }
    }
    
    let handleScroll = (event) => {
        if (tooltipContainer.current && tooltipContainer.current.contains(event.target)) {
            return;
        }
        timeouts = null;
        setIsOpen(false);
        props.onTooltipClose();
    }

    useEffect(() => {
        calculateTooltipPosition()
    }, [isOpen])
    
   
    useEffect(() => {
        showTooltip();
        if (props.hideOnDocClick) {
            document.body.addEventListener('click', handleClickOutside);
        }
        else {
            document.body.addEventListener('mousemove', onMouseMove);
        }
        window.addEventListener('scroll', handleScroll, true);


        return () => {
            document.body.removeEventListener('mousemove', onMouseMove);
            window.removeEventListener('scroll', handleScroll, true)

            if (timeouts) {
                clearTimeout(timeouts);
                timeouts = null;
            }
            if (props.hideOnDocClick)
                document.body.removeEventListener('click', handleClickOutside);
        }
    }, [props.hideOnDocClick])
    return ( isOpen &&
    <BodyPortal>
      <div className={`exz-tooltip-container toolTipMain ${props.toolTipClassName}`} style={customStyle?customStyle:tooltipStyles.position} ref={wrapperRef} >
          {tooltipStyles.arrow && <span className="customArrow" style={tooltipStyles.arrow}></span>}
          <div className= {`exz-tooltip ${tooltipStyles.className}`} ref={tooltipContainer}>
              <div className="content">
                  {props.children}
              </div>
          </div>
      </div>
      </BodyPortal>
    )
}

export default Tooltip
